import request from "../../../../../base/request";

const urlMap = {
    picture:"/search-server/search/getPublicList/picture",
    video:"/search-server/search/getPublicList/video",
    audio:"/search-server/search/getPublicList/audio",
};

const loadList = ({indexName,start,size,search,other})=>{
    return new Promise((resolve, reject) => {
        request({
            url: urlMap[indexName],
            contentType:"json",
            method:"post",
            body:{ pageNum:start,pageSize:size,keyword:search,...other },
            callBack:(data)=>{
                data&&data.data && data.data.map(item=>{
                    item.component = require(`../${indexName}/${indexName}`).default;
                });
                resolve(data);
            }
        })
    })
};
export default loadList;